import { get } from 'lodash';

import { DecimalNumber } from '@app/shared/common/decimal-number/decimal-number';

import { IQtyCalculatorParams } from './calculators.types';

const zeroQohCalculator = (params: IQtyCalculatorParams) => {
  const { threshold, replenishType, percent, measureFactor } = params;

  const replenishQuantity: DecimalNumber = new DecimalNumber(
    get(threshold, replenishType) || 0,
  )
    .mul(percent)
    .div(100);

  // [replenishQuantity * thresholdsMeasureFactorValue]
  let replenishmentValue: DecimalNumber = replenishQuantity.mul(
    measureFactor.threshold,
  );

  replenishmentValue = replenishmentValue.div(measureFactor.item);

  return replenishmentValue;
};

export { zeroQohCalculator };
